<template>
  <section class="_menu-section-style">  
    <form-section label="Depoimentos" v-model="isExpanded.testimonials">
      <draggable ghost-class="ghost" :list="selectedSection.items" @start="isDragging = true" @end="isDragging = false">
        <transition-group type="transition" name="list-complete">      
          <div v-for="(opt, index) in selectedSection.items" :key="index" class="show-cursor bgHover" no-gutters>
            <Expansion 
              v-model="opt.visible" 
              :verticalExpansion="false"
              @click="onOpen(index, opt.visible)"
            >
              <template slot="default">
                <section class="d-flex flex-column mb-2">
                  <div class="styles-item">
                    <expanded-icon :isExpanded="opt.visible"/>
                    <span :style="`font-weight: ${opt.visible ? '700' : '400'}`">Depoimento {{index + 1}}</span>
                    <div class="d-flex flex justify-end">
                      <DeleteButton @click="handleDelete(selectedSection.items, index)"/>       
                    </div>
                  </div>   
                </section>         
              </template>

              <template slot="expanded">
                <v-row no-gutters class="px-2 pb-6">
                  <v-col cols="12">
                    <TextArea placeholder="Depoimento" v-model="opt.text" :hideDetails="true"/>
                  </v-col>
                  <v-col cols="6" class="_pt _pr-">
                    <TextField label="Nome" v-model="opt.name"/>
                  </v-col>
                  <v-col cols="6" class="_pt _pl-">
                    <TextField label="Empresa" v-model="opt.company"/>
                  </v-col>
                </v-row>
              </template>
            </Expansion>

          </div>
        </transition-group>
      </draggable>

      <div class="d-flex flex-column _btn py-2">
        <ButtonV2 
          label="Novo depoimento" 
          color="bt_gray_bg"
          textColor="darkBlue"
          textSize="0.80rem"
          icon="fa-regular fa-comment"
          @click="handleAdd"
        />         
      </div>
    </form-section> 

    <form-section label="Título" v-model="isExpanded.title">
      <Texts 
        textType="title" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
        useTextArea
      />
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>

  </section>
</template>

<script>
import draggable from 'vuedraggable'
import { TESTIMONIALS_ITEM_OPTION } from '../../../schemas/sections'
import FormSection from '../../_v2/utils/FormSection.vue'
import ExpandedIcon from '../../_v2/utils/ExpandedIcon.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import ButtonV2 from '../../_v2/ui/Button.vue'
import Expansion from '../../_v2/ui/Expansion.vue'
import TextField from '../../_v2/ui/TextField.vue'
import DeleteButton from '../../_v2/ui/DeleteButton.vue'
import TextArea from '../../_v2/ui/TextArea.vue'

export default {
  name: 'TestimonialsSection',
  components: { FormSection, Texts, Background, ButtonV2, draggable, TextField, TextArea, ExpandedIcon, DeleteButton, Expansion },
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {title: false, subtitle: false, bg: false, testimonials: true},
  }),

  created () {
    this.selectedSection.items.forEach((item, index) => {
      item.visible = false
    })
  },

  beforeDestroy () {
    this.selectedSection.items.forEach(item => {
      item.visible = false
    })
  },

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    onOpen (index, state) {
      if (state && this.selectedSection.items && this.selectedSection.items.length > 0) {
        this.selectedSection.items.forEach((option, i) => {
          if (i !== index) option.visible = false
        })
      }
    },

    handleAdd () {
      this.selectedSection.items.forEach(item => { item.visible = false })
      const newTestimonials = TESTIMONIALS_ITEM_OPTION()
      newTestimonials.visible = true
      this.selectedSection.items.push(newTestimonials)
    },

    handleDelete (array, index) {
      array.splice(index, 1)
    }
  }    
}
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    cursor: move !important
  }

  .styles-item {
    display: flex;
    gap: 10px;
    height: 50px;
    align-items: center;
    font-size: 0.9rem;
    transition: all 0.3s;
    padding: 0 8px 0 8px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
  }

  .styles-item span {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  .styles-item:hover {
    cursor: pointer;
    animation: changeCursor 3s forwards;
  }

  .show-cursor {
    cursor: move !important;
    transition: all 0.3s;    
  }

  .show-cursor:hover {
    border-radius: 4px;
  }

  .bgHover:hover {
    background-color: #FAFBFB;    
  }

  @keyframes changeCursor {
    100% {
      cursor: move;
    }
  }

  .list-complete-item {
    transition: all 0.8s;
    display: inline-block;
    margin-right: 10px;
  }

  .list-complete-enter, .list-complete-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }

  .list-complete-leave-active {
    position: absolute;
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
  }  
</style>